import { useFormContext } from "react-hook-form";
import { Input as InputBase, InputFeedback } from "@songtradr/design-language";
import { Container, Props } from "./Input.Parts";

export const Input = ({
  id,
  registerOptions,
  errorMessage,
  ...rest
}: Props) => {
  const {
    register,
    formState: { isSubmitting, isSubmitted, errors },
  } = useFormContext();

  const invalid =
    isSubmitted &&
    Boolean(errorMessage || errors.root?.message || errors[id]?.message);

  return (
    <Container>
      <InputBase
        id={id}
        aria-invalid={invalid}
        disabled={isSubmitting}
        hasError={invalid}
        {...register(id, registerOptions)}
        {...rest}
      />
      {invalid && (
        <InputFeedback
          message={errorMessage ?? errors[id]?.message?.toString()}
        />
      )}
    </Container>
  );
};
